export default {
	ContactAdditionalData: function(state) {
		return state.ContactAdditionalData;
	},

	Total: function(state) {
		return state.Total;
	}
};
